import PlatformIcon from "../../../common/components/Icon/PlatformIcon/PlatformIcon";
import { prettifyPlatformName } from "../../../common/util/prettifyPlatformName";

export const availablePlatforms = [
  "OculusQuest",
  "PicoNeo",
  "Android",
  "iPhone",
  "iPad",
  "MacOS",
  "Windows10",
  "WebGLiframe",
  "WebGLApp",
  "WebGLApp_scorm",
];

export interface IPurePlatformCard {
  id: string;
  component: any;
}

const mapPlatformName = (platformName: string): string => {
  if (platformName === "OculusQuest") return "MetaQuest";
  return platformName;
};

const PlatformCards = availablePlatforms.map((platformName: string, i: number) => {
  const displayName = mapPlatformName(platformName);
  return {
    id: platformName,
    component: (
      <div
        key={`iii${i}-${platformName}`}
        id={`platform-card-${platformName}`}
        className="flex flex-col items-center justify-center transform"
      >
        <PlatformIcon platform={platformName} iconProps={{ width: 25, height: 25 }} />
        <p className="mt-2 font-bold text-sm">{prettifyPlatformName(displayName)}</p>
      </div>
    ),
  };
});

export default PlatformCards;
